import {  ReactNode, cloneElement, ReactElement } from 'react';

type WithConditionalWrapperHocProps = {
  useWrapper: boolean;
  wrapper: ReactElement;
  children: ReactNode;
};

export const WithConditionalWrapperHoc = ({ useWrapper, wrapper, children }: WithConditionalWrapperHocProps): JSX.Element => {
  return useWrapper ? cloneElement(wrapper, {}, children) : <>{children}</>;
};
